module.exports = __webpack_public_path__ + "static/media/logo.00d8628e.svg";